/** @file English catalog part of area E4 (W3-03); replaced whole by that area. */

/** The `curves` block (the Curves tab of the Timeline panel). S0 composes it into `en`. */
export const curvesEn = {
  tab: 'Curves', graph: 'Curve graph', toolbar: 'Curve tools',
  empty: 'Select keys, bones or slots of the current animation to see their curves.',
  preset: {
    linear: 'Linear', stepped: 'Stepped', ease: 'Ease', easeIn: 'Ease in', easeOut: 'Ease out', easeInOut: 'Ease in-out',
    backIn: 'Back in', backOut: 'Back out',
  },
  copyShape: 'Copy shape to selection', copyShapeFlat: 'This segment keeps one value, so it has no shape to copy.',
  normalize: 'Normalize', showValues: 'Show values', frameAll: 'Frame all',
} as const;
